import { Endpoints } from '@/api/ApiEndpoints';

const Teams = {
	Plural: 'Teams',
	Single: 'Team',
	ModalForm: true,
	DefaultSorting: 'Name',
	DefaultSortingType: 'desc',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'name',
			dbName: 'Name',
			label: 'Name',
			sortable: true,
			required: true,
			type: 'text',
		},
		
		
	],
	Filters: [
		
	],
	PrimaryKey: 'id',
	Actions: {
		addLink: '/teams/add/',
		editLink: '/teams/edit/',
		
	},
};

export default Teams;
